import { Badge } from 'antd';
import { PresetStatusColorType } from 'antd/lib/_util/colors';
import styled from 'styled-components';

export const Wrapper = styled.div`
    white-space: nowrap;
`;

export const StyledBadge = styled(Badge)<{ status?: PresetStatusColorType }>`
    .ant-badge-status-dot {
        ${({ status }) => {
            switch (status) {
                case 'success':
                    return 'background-color: var(--success-normal) !important;';
                case 'warning':
                    return 'background-color: var(--warning-normal) !important;';
                case 'error':
                    return 'background-color: var(--error-normal) !important;';
                case 'processing':
                    return 'background-color: var(--processing-normal) !important;';
                case 'default':
                    return 'background-color: var(--disabled-normal) !important;';
                default:
                    return 'background-color: var(--disabled-normal) !important;';
            }
        }}
    }

    /* Stop the pulsing animation for processing */
    .ant-badge-status-processing {
        &::after {
            animation: none !important;
        }
    }
`;
